import { StreamingWidgetState } from 'widgets/store/stream/WidgetStreamState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import {
    initialPortfolioPlStreamState,
    PortfolioPlDataState,
} from 'widgets/portfolioPl/store/stream/PortfolioPlWidgetStreamState';
import {
    initialPortfolioPlConfigState,
    PortfolioPlWidgetConfigState,
} from 'widgets/portfolioPl/store/config/PortfolioPlWidgetConfigState';

export type PortfolioPlWidgetState =
    StreamingWidgetState<PortfolioPlDataState> &
        WidgetWithConfigState<PortfolioPlWidgetConfigState>;

export interface PortfolioPlWidgetsState {
    [widgetId: string]: PortfolioPlWidgetState;
}

export const initialPortfolioPlWidgetState: PortfolioPlWidgetState = {
    config: initialPortfolioPlConfigState,
    stream: initialPortfolioPlStreamState,
};

export const initialPortfolioPlWidgetsState: PortfolioPlWidgetsState = {};
